import { PartiallyRequired } from "@/types/helper";

// Interfaces
export interface TagAssignParams {
    locationId: string;
    listId: string;
    listItemId: string;
    tagId: string;
}

export interface IManualSortingData {
    listId: string;
    index: number;
    selectedProducts: Record<string, boolean>
}

export type RequiredListLocation = PartiallyRequired<PartiallyRequired<Partial<GetListItemsParams>, 'locationId'>, 'listId'>

// Classes
class GetListItemsParams {
    public locationId: string;
    public listId: string;
    public searchKey?: string | undefined;
    public category?: string | undefined;
    public tags?: string | undefined;
    public sortDesc?: boolean | undefined;
    public skip?: number | undefined;
    public take: number;
    public sortField?: string | undefined;
    public withQuantity?: boolean;
    public targetStock?: number;
    public currentStock?: number;
    public manualSort: boolean;
    public debounce?: boolean;

    public constructor(params: RequiredListLocation) {
        this.locationId = params.locationId
        this.listId = params.listId
        this.searchKey = params.searchKey ?? undefined
        this.category = params.category ?? undefined
        this.tags = params.tags ?? undefined
        this.sortDesc = params.sortDesc ?? undefined
        this.skip = params.skip ?? undefined
        this.take = params.take ?? 0
        this.targetStock = params.targetStock ?? 0
        this.currentStock = params.currentStock ?? 0
        this.sortField = params.sortField ?? 'name'
        this.withQuantity = params.withQuantity ?? false
        this.manualSort = params.manualSort ?? false
        this.debounce = params.debounce
    }
}

export interface AddInformationItemParams {
    locationId: string;
    listId: string;
    informationId: string;
    productId: string;
    quantity: number;
    targetStock?: number;
}

export interface AddInformationCartParams {
    locationId: string;
    informationId: string;
    productId: string;
    quantity: number;
    supplierId?: string;
    offset?: number;
}

export {
    GetListItemsParams
}
